/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface StageCreate {
  /**
     * @minLength 1
     * @maxLength 100
     */
  name: string;
  /**
     * @minLength 4
     * @maxLength 7
     * @pattern ^#[0-9a-fA-F]{3,6}$
     */
  color?: string;
  /** @maxLength 1000 */
  description?: string;
}
